__turbopack_context__.v({
  "mediamachineblock": "MediaMachineBlock-module-sass-module__LoZ7EW__mediamachineblock",
  "mediamachineblock__animation--in": "MediaMachineBlock-module-sass-module__LoZ7EW__mediamachineblock__animation--in",
});
